import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import ExitPopupSignup from "../exit-popup-signup/exit-popup-signup-component";
import { componentStyle, closeIconStyle } from "./exit-popup-content-component.scss";
class ExitPopupContent extends PureComponent {
    render() {
        const { title, subtitle, signupHeaderText, singupInputPlaceholder, signupButtonText, signupFooterText, onClose, origin } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${closeIconStyle.__hash} jsx-${componentStyle.__hash}` + " " + "exit-popup-content-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${closeIconStyle.__hash} jsx-${componentStyle.__hash}` + " " + "exit-popup-close",
                    children: /*#__PURE__*/ _jsx("a", {
                        rel: "nofollow",
                        onClick: onClose,
                        className: `jsx-${closeIconStyle.__hash} jsx-${componentStyle.__hash}` + " " + "x-button pointer tc",
                        children: "+"
                    })
                }),
                /*#__PURE__*/ _jsx("h3", {
                    className: `jsx-${closeIconStyle.__hash} jsx-${componentStyle.__hash}` + " " + "content-title",
                    children: title
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: `jsx-${closeIconStyle.__hash} jsx-${componentStyle.__hash}` + " " + "content-subtitle",
                    children: subtitle
                }),
                /*#__PURE__*/ _jsx(ExitPopupSignup, {
                    headerText: signupHeaderText,
                    inputPlaceholder: singupInputPlaceholder,
                    buttonText: signupButtonText,
                    footerText: signupFooterText,
                    onClickFooterText: onClose,
                    origin: origin
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyle.__hash,
                    children: componentStyle
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: closeIconStyle.__hash,
                    children: closeIconStyle
                })
            ]
        });
    }
}
export { ExitPopupContent as default };
